/* eslint-disable no-continue */
/* eslint-disable no-param-reassign */
import moment from "moment";
import { amountFields, dateFields } from "../../Constant";

export const typeConversion = (field, value) => {
  if (!amountFields[field] && value) {
    value = value.toLocaleString(undefined, { maximumFractionDigits: 2 });
  }
  if (dateFields[field]) {
    value = moment(value).format("DD MMM YYYY");
  }
  return value || 0;
};

export const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const saveExcelBlob = ({ blob, fileName = "Report.xlsx" }) => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
};

export const convertCamelCaseToTitles = (stringInCamel) => {
  let finalWord = stringInCamel[0].toUpperCase();
  let word1 = "";
  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const index in stringInCamel) {
    if (stringInCamel[index] === stringInCamel[index].toUpperCase()) {
      finalWord += word1;
      word1 = ` ${stringInCamel[index]}`;
      continue;
    }
    if (Number(index) === 0) {
      continue;
    }
    word1 += stringInCamel[index];
  }
  finalWord += word1;
  return finalWord;
};

export const getSettlementTemplateString = (config, sourceTemplateString) => {
  const templateString = {};
  const allowedKeys = ["finalNetDue", "flatFeeShare", "revenueShare", "baselineShare", "contractualDue", "digitalDiscountByChalo", "netDueAmount", "ledgerDate", "action", "detail", "busNumber", "fromDate", "netDue", "dueGeneratedAmount", "operatorPaymentAmount", "amountSettled"];
  Object.keys(sourceTemplateString).forEach((key) => {
    if ((config[key] && sourceTemplateString[key]) || allowedKeys.includes(key)) {
      templateString[key] = sourceTemplateString[key];
    }
  });
  return templateString;
};
